import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-menu__buttons" }

import { computed, ref } from "vue";
import { useHeader } from "@/composables/use-header";
import { getJackpotsForPopupBanners } from "@/api-connector/sazka-api/methods/draw-info-api";
import BonusBanner from "@/components/header/navigation-buttons-authenticated/bonus-banner.vue";
import PopupBanners from "@/components/header/navigation-buttons-authenticated/popup-banners.vue";
import DrawAttendance from "@/components/header/navigation-buttons-authenticated/draw-attendance.vue";
import UserBalance from "@/components/header/navigation-buttons-authenticated/user-balance.vue";
import { isObtainableBonusOpen, storeObtainableBonusClosed } from "@/account/composables/user-cookies";
import { useUserData } from "@/account/use-user-data";
import { Loader } from "@sazka/design-system/src/loader/loader";
import { settings } from "@/settings";


export default /*@__PURE__*/_defineComponent({
  __name: 'navigation-buttons-authenticated',
  setup(__props) {

const { drawAttendancePopupVisible, userBalancePopupVisible, closeMenu } = useHeader();
const { userWalletData } = useUserData();

const popupBannersModalVisible = ref<boolean>(false);
const jackpotSportka = ref<number>(0);
const jackpotEurojackpot = ref<number>(0);

const openPopupBannersModal = async () => {
    Loader.show();

    try {
        const jackpots = await getJackpotsForPopupBanners();
        jackpotSportka.value = jackpots.Sportka.value;
        jackpotEurojackpot.value = jackpots.Eurojackpot.value;
    } catch (err) {
        console.error(err);
    }

    popupBannersModalVisible.value = true;
    drawAttendancePopupVisible.value = false;
    Loader.hide();
};

const closePopupBannersModal = async () => {
    popupBannersModalVisible.value = false;
};

const toggleDrawAttendancePopup = async () => {
    drawAttendancePopupVisible.value = !drawAttendancePopupVisible.value;
    userBalancePopupVisible.value = false;
    closeMenu();
};

const toggleUserBalancePopup = async () => {
    userBalancePopupVisible.value = !userBalancePopupVisible.value;
    drawAttendancePopupVisible.value = false;
    closeMenu();
};

const showObtainableBonus = computed(() => {
    return isObtainableBonusOpen.value && window.location.pathname == settings.url.root;
});

const closeBonusBannerHandler = async () => {
    storeObtainableBonusClosed();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PopupBanners, {
        "popup-banners-modal-visible": popupBannersModalVisible.value,
        "jackpot-sportka": jackpotSportka.value,
        "jackpot-eurojackpot": jackpotEurojackpot.value,
        onClosePopupBannersModal: closePopupBannersModal
      }, null, 8, ["popup-banners-modal-visible", "jackpot-sportka", "jackpot-eurojackpot"]),
      _createVNode(DrawAttendance, {
        "draw-attendance-popup-visible": _unref(drawAttendancePopupVisible),
        draws: _unref(userWalletData).draws,
        onOpenPopupBannersModal: openPopupBannersModal,
        onToggleDrawAttendancePopup: toggleDrawAttendancePopup
      }, null, 8, ["draw-attendance-popup-visible", "draws"]),
      _createVNode(UserBalance, {
        "user-balance-popup-visible": _unref(userBalancePopupVisible),
        "withdrawable-amount": _unref(userWalletData).withdrawableAmount,
        "withdrawal-expiration": _unref(userWalletData).withdrawalExpiration,
        onToggleUserBalancePopup: toggleUserBalancePopup
      }, null, 8, ["user-balance-popup-visible", "withdrawable-amount", "withdrawal-expiration"])
    ]),
    (showObtainableBonus.value)
      ? (_openBlock(), _createBlock(BonusBanner, {
          key: 0,
          onCloseBonusBanner: closeBonusBannerHandler
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})